import {Injectable, Output} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {UserService} from "./user.service";

@Injectable()
export class AnnouncementService {

    constructor(private userService: UserService) {
    }
    public saveAnnouncement(object): Observable<any> {
        return this.userService.request('post', 'saveannouncement',object);
    }
    public getAnnouncementList(perpage,page): Observable<any> {
        return this.userService.request('get', 'getannouncements',null,{perpage:perpage,page:page});
    }
    public changeAnnouncementStatus(id,status): Observable<any> {
        return this.userService.request('get', 'upannoucestatus',null,{id:id,status:status});
    }
    public delete(id): Observable<any> {
        return this.userService.request('get', 'deleteannounce',null,{id:id});
    }

}



// WEBPACK FOOTER //
// ./src/app/services/announcement.service.ts